var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticStyle:{"height":"100vh","width":"100%","background-color":"#fff"}},[_c('div',{staticStyle:{"font-size":"2rem","color":"#ff5722","text-align":"center","margin-top":"5%"}},[_vm._v(" INVALID URL!!! ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }